import type { DateString } from 'zapatos/db';
import { DATE_REGEXP, EMAIL_REGEXP } from './regexp';

export const isValidEmail = (email?: string): boolean => {
    if (!email) return false;
    return EMAIL_REGEXP.test(email);
};

export const isValidDateString = (
    dateStr?: string | null
): dateStr is DateString => {
    if (!dateStr) return false;
    return DATE_REGEXP.test(dateStr);
};
